import React, { useState,useEffect } from "react";
import desktopLogo from "../assests/images/desktopLogo.svg";
import hamburgerIcon from "../assests/images/hamburgerIcon.svg";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import cross from "../assests/images/cross.svg";
import { useLocation } from "react-router-dom";
import AdminNavbarMenu from "./AdminNavbarMenu";
export default function AdminNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDesktop } = useResponsiveFlags();
  const location =useLocation();
  const toggleMenu = () =>{
    setIsMenuOpen(!isMenuOpen);
  };
  useEffect(()=>{
    setIsMenuOpen(false);

  },[location.pathname]);
  return (
      <>
        {isDesktop ? (
          <>
            <div
              className="d-flex flex-column"
              style={{
                backgroundColor: "#031621",
                height: "100vh",
                position: "fixed",
                zIndex: "1000",
              }}
            >
              <div className="navbar-menu-logo">
                <img src={desktopLogo} />
              </div>
              <AdminNavbarMenu />
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                ...(isMenuOpen && {height: "100%"}),
                position: "fixed",
                width: "100vw",
                zIndex: "1000",
                display:"flex",
                flexDirection: "column",
              }}
            >
              {" "}
              <div
                className="d-flex justify-content-between w-100"
                style={{ backgroundColor: "#031621"}}
              >
                <div className="navbar-menu-logo" style={{}}>
                  <img src={desktopLogo} />
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleMenu}
                  aria-expanded={isMenuOpen}
                  aria-label="Toggle"
                >
                  <span>
                    <img
                      // src={hamburgerIcon}
                      src={isMenuOpen ? cross : hamburgerIcon}
                      alt=""
                      style={{ marginRight: "1rem" }}
                    />
                  </span>
                </button>
              </div>
              {isMenuOpen ? (
                <>
                  <div
                    id="Toggle"
                    className="flex-grow-1 justify-content-end d-flex"
                    style={{
                      width: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      zIndex: "100",
                      overflowY:"scroll",
                      borderTop:"1px solid #434343",
                    }}
                  >
                    <AdminNavbarMenu />
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </>
        )}
      </>
    );
}